<template>
  <div class="background-input-botton">
    <small class="small-text">{{ $t('ia.chat.textError') }}</small>
    <div class="div-input-button">
      <textarea
        autocomplete="off" 
        :placeholder="placeholder" 
        class="size-input"
        :value="value"
        @input="$emit('input', $event.target.value)"
        @keydown.enter.exact.prevent="$emit('send')"
        ref="textInput"
        @focus="$emit('focus')"
        @blur="$emit('blur')"
        rows="1"
      />
      <b-button
        class="generate-img-ai"
        v-if="!loading"
        @click="$emit('send')"
        :disabled="!value"
      >
        <feather-icon icon="SendIcon" class="send-icon" />
        <b-badge class="badge-button-ia">
          <feather-icon icon="CodesandboxIcon" class="icon-ia" />
          <slot name="credits" />
        </b-badge>
      </b-button>
      <b-skeleton v-else type="button" class="generate-img-ai" />
    </div>
  </div>
</template>

<script>
import { BButton, BBadge, BSkeleton } from 'bootstrap-vue';

export default {
  name: 'ChatInput',
  components: { BButton, BBadge, BSkeleton },
  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    loading: { type: Boolean, default: false }
  },
  watch: {
    value() {
      this.$nextTick(() => this.autoResize());
    }
  },
  methods: {
    autoResize() {
      const el = this.$refs.textInput;
      if (el) {
        el.style.height = 'auto';
        el.style.height = `${Math.min(el.scrollHeight, 140)}px`;
      }
    }
  }
}
</script>

<style scoped lang="scss">
.background-input-botton {
  width: 100%;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  
  .small-text {
    background-color: #eeeeee;
    padding: 0.2em 0.5em;
    font-family: 'avenir-light';
    border-radius: 1em;
    margin: 0.4em 0;
  }
  
  .div-input-button {
    width: 100%;
    backdrop-filter: blur(2px);
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 0.5rem;
    padding: 0.5em;
    display: flex;
    align-items: flex-end;
    gap: 0.5em;
    
    .send-icon {
      height: 20px;
      width: 20px;
      margin-right: 0.5em;
    }
    
    .badge-button-ia {
      display: flex;
      align-items: center;
      margin-left: 0.5em;
      font-size: 12px;
      background-color: #40736E;
      
      .icon-ia {
        width: 20px;
        height: 20px;
        margin-right: 0.2em;
      }
    }
    
    .generate-img-ai {
      height: 42px;
      min-height: 42px;
      display: flex;
      align-items: center;
      flex-shrink: 0;
      background: linear-gradient(to left bottom, rgb(124, 214, 175), rgb(62, 123, 160));
    }
    
    .size-input {
      resize: none;
      background-color: transparent;
      min-height: 42px;
      max-height: 140px;
      flex-grow: 1;
      font-size: 15px;
      font-weight: bold;
      border: none;
      box-shadow: none !important;
      font-family: monospace !important;
      line-height: 1.5;
      padding: 0.6em 0;
      overflow-y: auto;

      @media(max-width: 500px) {
        font-size: 14px;
      }
      
      &::placeholder {
        color: #70747c;
      }
    }
  }
}
</style>
